const getters = {
  roles: state => state.user.roles,
  permissions: state => state.user.permissions
}
export default getters
